import * as React from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { baseActions } from "../models/BaseSlice";
import CommonUtils from "../utils/CommonUtils";
import Api, { APIs } from "../../../Api";
import { useEffect, useState } from "react";

type Anchor = "top";

export default function TopDrawer() {
    const navigate = useNavigate();
    const [compareType, setCompareType] = useState("");
    const [compareOption1, setCompareOption1] = useState("");
    const [compareOption2, setCompareOption2] = useState("");
    const openTopDrawer = useSelector((state: any) => state?.base?.openTopDrawer);
    const dispatch = useDispatch();

    const [donor, setDonor] = useState<string[]>([]);
    const [sector, setSector] = useState<string[]>([]);
    const [region, setRegion] = useState<string[]>([]);

    const [disabled, setDisabled] = useState(true);
    const noSelect = [""];

    useEffect(() => {
        Api.get(APIs.MoPD_UNIQUE_LIST).then((payload: any) => {
            payload.donor.unshift('Select Donor');
            payload.region.unshift('Select Region');
            const sectors = Object.keys(payload.sector).map((no) => "SRO" + no);
            sectors.unshift('Select Sector');
            setDonor(payload.donor);
            setRegion(payload.region);
            setSector(sectors);
        });
    }, []);

    function handleChange(event: any) {
        const value = event.target.value;
        setCompareType(value);
        setDisabled(value === "noselect");
    }

    let type: any = null;
    let options: any = null;

    if (compareType === "noselect") type = noSelect;
    if (compareType === "donor") type = donor;
    else if (compareType === "sector") type = sector;
    else if (compareType === "region") type = region;

    if (type) options = type.map((el: string) => (
        <option key={el} value={el.indexOf("Select") === -1 ? el.replace("/", "$") : ""}>{el}</option>
    ));

    const toggleDrawer = (open: boolean) => {
        dispatch(baseActions.setOpenTopDrawer(open));
        if (!open) {
            setCompareOption1('');
            setCompareOption2('');
            setDisabled(true);
        }
    }

    const handleClose = () => {
        toggleDrawer(false);
        setCompareType("");
        setCompareOption1("");
        setCompareOption2("");
    }

    const getForm = (anchor: Anchor) => (
        <Box
            sx={{
                width: anchor === "top" || anchor === "bottom" ? "100vw" : 250,
                height: "contentFit",
                padding: 1,
                backgroundColor: "lightgray"
            }}
            role="presentation"
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <h3 style={{
                    backgroundColor: "#414141",
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: "10px"
                }}>COMPARISON</h3>
                <label>
                    <select
                        onChange={handleChange}
                        value={compareType}
                        style={{ width: "100%", height: "30px", paddingLeft: 10 }}
                    >
                        <option value="noselect">Please select</option>
                        <option value="donor">Donor</option>
                        <option value="sector">Sector</option>
                        <option value="region">Region</option>
                    </select>
                </label>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                    }}
                >
                    <select
                        onChange={(e) => setCompareOption1(e.target.value.indexOf("Select") === -1 ? e.target.value : '')}
                        value={compareOption1}
                        style={{ width: "50%", height: "30px", paddingLeft: 10 }}
                        disabled={disabled}
                    >
                        {options}
                    </select>

                    <select
                        onChange={(e) => setCompareOption2(e.target.value.indexOf("Select") === -1 ? e.target.value : '')}
                        value={compareOption2}
                        style={{
                            width: "50%",
                            height: "30px",
                            paddingLeft: 10,
                            marginLeft: "50px",
                        }}
                        disabled={disabled}
                    >
                        {options}
                    </select>
                </Box>
                <br />
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#414141",
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: "10px"
                }}>
                    <button
                        style={{
                            fontSize: 20,
                            borderRadius: 5,
                        }}
                        disabled={disabled}
                        onClick={() => {
                            if (compareOption1 !== "" && compareOption2 !== "") {
                                const qType = compareType === "sector" ? "sro" : compareType;
                                navigate(`/compare?type=${qType}&o1=${compareOption1}&o2=${compareOption2}`);
                                handleClose();
                                CommonUtils.showSnackbar(`Comparing ${qType}, ${compareOption1} with ${compareOption2}`);
                            } else {
                                CommonUtils.showSnackbar("Please select options");
                            }
                        }}
                    >
                        Compare
                    </button>
                    <button
                        onClick={handleClose}
                        style={{
                            fontSize: 20,
                            marginLeft: "20px",
                            backgroundColor: "red",
                            color: "white",
                            borderRadius: 5,
                        }}
                    >
                        Close
                    </button>
                </div>
            </Box>
        </Box>
    );

    return (
        <React.Fragment>
            {(["top"] as const).map((anchor) => (
                <React.Fragment key={anchor}>
                    <SwipeableDrawer
                        anchor={anchor}
                        sx={{ width: "100%" }}
                        open={openTopDrawer}
                        onClose={() => toggleDrawer(false)}
                        onOpen={() => toggleDrawer(true)}
                    >
                        {getForm(anchor)}
                    </SwipeableDrawer>
                </React.Fragment>
            ))}
        </React.Fragment>
    );
}
